import MuiDatePicker from "Global/Components/UnEditableComponents/MuiDatePicker/MuiDatePicker";
import React from "react";
import FindLangKey from "Global/Functions/FindLangKey/FindLangKey";
import i18next from "i18next";
import ReceiptType from "../components/ReceiptType";
import ReceiptMonth from "../components/ReceiptMonth";

const useCreateFormElements = (params) => {
  const year_select_msg = FindLangKey("invoice-receipt-label-select-year");

  const elements = [
    {
      element: (
        <MuiDatePicker
          openTo="year"
          Placeholder={year_select_msg}
          isSmall={true}
        />
      ),
      name: "Year",
      required: true,
    },
    {
      element: (
        <ReceiptMonth
          monthList={params?.MonthList}
          initial={params?.FromMonth}
        />
      ),
      name: "FromMonth",
      required: true,
    },
    {
      element: (
        <ReceiptType
          receiptTypeList={params?.FishTypeList}
          initial={params?.FishTypeID}
          fishTypeId={params?.FishTypeID}
        />
      ),
      name: "FishTypeID",
      required: true,
    },
  ];

  return elements;
};

export default useCreateFormElements;
